var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_533_464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46Z",
    fill: "#00BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7044 7.97095H7.97095V38.0291H31.2225V15.4819L23.7044 7.97095Z",
    fill: "#EFF3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7043 15.4819H31.2225L23.7043 7.97095V15.4819Z",
    fill: "#DBDFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9456 13.7712H20.9587V15.4819H11.9456V13.7712Z",
    fill: "#DBDFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9456 18.321H27.2406V20.0317H11.9456V18.321Z",
    fill: "#DBDFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9456 22.8706H27.2406V24.5812H11.9456V22.8706Z",
    fill: "#DBDFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9456 27.4204H27.2406V29.131H11.9456V27.4204Z",
    fill: "#DBDFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9456 31.97H27.2406V33.6806H11.9456V31.97Z",
    fill: "#DBDFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5261 22.0081H30.5108V38.0362H29.5261V22.0081Z",
    fill: "#788D9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0081 29.5261H38.0362V30.5108H22.0081V29.5261Z",
    fill: "#788D9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.015 36.268C26.5722 36.268 23.769 33.4649 23.769 30.0221C23.769 26.5792 26.5722 23.7761 30.015 23.7761C33.4578 23.7761 36.2609 26.5792 36.2609 30.0221C36.2681 33.4649 33.465 36.268 30.015 36.268ZM30.015 24.7536C27.1112 24.7536 24.7537 27.1111 24.7537 30.0149C24.7537 32.9186 27.1112 35.2761 30.015 35.2761C32.9187 35.2761 35.2762 32.9186 35.2762 30.0149C35.2834 27.1183 32.9187 24.7536 30.015 24.7536Z",
    fill: "#F1786B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.015 34.0471C27.7941 34.0471 25.99 32.243 25.99 30.0221C25.99 27.8011 27.7941 25.9971 30.015 25.9971C32.2359 25.9971 34.04 27.8011 34.04 30.0221C34.0472 32.2358 32.2359 34.0471 30.015 34.0471ZM30.015 26.9746C28.3403 26.9746 26.9747 28.3402 26.9747 30.0149C26.9747 31.6896 28.3403 33.0552 30.015 33.0552C31.6969 33.0624 33.0625 31.6968 33.0625 30.0149C33.0625 28.3402 31.6969 26.9746 30.015 26.9746Z",
    fill: "#F1786B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.589 30.015C31.589 30.8847 30.8847 31.589 30.015 31.589C29.1453 31.589 28.4409 30.8847 28.4409 30.015C28.4409 29.1453 29.1453 28.4409 30.015 28.4409C30.8847 28.4481 31.589 29.1525 31.589 30.015Z",
    fill: "#F1786B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_533_464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSop);
export default __webpack_public_path__ + "static/media/sop.a14fd4c19eca300a60236ded2fb53fe0.svg";
export { ForwardRef as ReactComponent };